import {
  all,
  takeEvery,
  put,
  call,
  select,
  take,
} from "@redux-saga/core/effects";
import {
  BULKAPPROVEREMEDIATIONTRACKERTASK,
  BULKREJECTREMEDIATIONTRACKERTASK,
  CHECKBULKAPPROVEREMEDIATIONTRACKERTASK,
  CHECKBULKREJECTREMEDIATIONTRACKERTASK,
  DELETEREMEDIATIONTRACKERTASK,
  DELETEREMEDIATIONTRACKERTASKS,
  GETREMEDIATIONTRACKERTASINITIALDATA,
  GETREMEDIATIONTRACKERTASKSDETAILS,
  GETREMEDIATIONTRACKERTASKSLIST,
  GETREMEDIATIONtASKQUESTIONDETAILS,
  MERGEREMEDIATIONTRACKERTASKS,
  UNMERGEREMEDIATIONTRACKERTASKS,
  bulkApproveRemediationTrackerTask,
  bulkRejectRemediationTrackerTask,
  getRemediationTrackerTaskList,
} from "./RemediationTrackerTasksPage.action";
import {
  getRemediationTrackerTaskStatisticsApi,
  getRemediationTrackerTaskDetails,
  getRemediationTrackerTaskInitialData,
  getRemediationTrackerTaskListApi,
  deleteRemediationTasksSubtasksApi,
  unMergeRemediationTasksApi,
  mergeRemediationTasksApi,
  getRemediationTrackerTaskQuestionDetailsApi,
  bulkApproveRemediationTrackerTaskApi,
  bulkRejectRemediationTrackerTaskApi,
  CheckBulkApproveRejectRemediationTrackerTaskApi,
} from "./RemediationTrackerTasksPage.api";
import {
  MergeRemediationRequestDTO,
  RemediationTrackerTaskQuestionsRequestDTO,
  RemediationTrackerTasksPageType,
  ViewDetailsPopupDataType,
} from "./RemediationTrackerTasksPage.types";
import { AnyAction } from "redux";
import { remediationTrackerTasksReducerActions } from "./RemediationTrackerTasksPage.reducer";

import {
  BulkApproveRemediationTrackerTaskDTO,
  BulkRejectRemediationTrackerTaskDTO,
  CheckApprovalDTO,
  ParentChildApprovalRejectionDataDTO,
  RemediationTrackerTaskCommentDTO,
  RemediationTrackerTaskGridData,
  RemediationTrackerTaskSearchParameter,
} from "../../../common/types/common.dto.types";
import {
  setLoading,
  setPopupOpen,
} from "../../layouts/main-layout/MainLayout.reducer";
import { ActionResponseType } from "../../../common/types/common.types";
import {
  openPopup,
  updatePopupProps,
} from "../../../components/Popups/Popup.reducer";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { RootState } from "../../../core/store";
import { channel } from "redux-saga";
import { callAllApiRequest } from "../../../core/api/apiClient.service";

// ==============================|| VIEWS - PAGES - REMEDIATION TRACKER TASKS - SAGA ||============================== //

// Watcher for Bulk Approval channel
const bulkApprovalChannel = channel();

// Watcher for Bulk Approval channel
const bulkRejectChannel = channel();

/**
 * A custom Redux Saga channel used for reducer-related actions.
 */
const reducerChannel = channel();

export function* bulkApprovalChannelWatcher() {
  while (true) {
    const action = yield take(bulkApprovalChannel);
    yield put(action);
  }
}

export function* bulkRejectChannelWatcher() {
  while (true) {
    const action = yield take(bulkRejectChannel);
    yield put(action);
  }
}

const getRemediationTrackerTaskChannel = channel();
export function* getRemediationTrackerTaskChannelWatcher() {
  while (true) {
    const action = yield take(getRemediationTrackerTaskChannel);
    yield put(action);
  }
}

export function* reducerChannelWatcher() {
  while (true) {
    const action = yield take(reducerChannel);
    yield put(action);
  }
}

const getRemediationTrackerTaskInitialDataWatcher = function* (): any {
  yield takeEvery(
    GETREMEDIATIONTRACKERTASINITIALDATA,
    function* (action: AnyAction): any {
      const result: ActionResponseType = yield call(
        getRemediationTrackerTaskInitialData
      );

      if (result.IsSuccess) {
        yield put(
          remediationTrackerTasksReducerActions.setDropDownList(result.Data)
        );
        yield put(
          remediationTrackerTasksReducerActions.setRemediationTaskSystemConfiguration(
            result.Data
          )
        );

        const state: RemediationTrackerTasksPageType = yield select(
          (s: RootState) => s.remediationTrackerTasksReducer
        );

        // yield put(
        //   remediationTrackerTasksReducerActions.setRemediationTrackerTaskSearchParameter(
        //     state.TaskSearchParameter
        //   )
        // );
      }
    }
  );
};

const getRemediationTrackerTaskListWatcher = function* (): any {
  yield takeEvery(
    GETREMEDIATIONTRACKERTASKSLIST,
    function* (action: AnyAction): any {
      const state: RemediationTrackerTasksPageType = yield select(
        (s: RootState) => s.remediationTrackerTasksReducer
      );

      // set page loading
      if (!state.DataLoading) {
        yield put(remediationTrackerTasksReducerActions.setDataLoading(false));
        yield put(setLoading(true));
      }

      const searchParameters: RemediationTrackerTaskSearchParameter = {
        ...action.payload.searchParameter,
      };

      const [taskListResult, statisticsResult]: [
        ActionResponseType,
        ActionResponseType
      ] = yield all([
        call(getRemediationTrackerTaskListApi, searchParameters),
        call(getRemediationTrackerTaskStatisticsApi, searchParameters),
      ]);

      if (!taskListResult.IsSuccess) {
        // TODO document why this block is empty
      } else {
        yield put(
          remediationTrackerTasksReducerActions.setRemediationTrackerTaskList(
            taskListResult?.Data?.Data
          )
        );

        yield put(
          remediationTrackerTasksReducerActions.setRemediationTrackerTaskSearchParameter(
            {
              ...searchParameters,
              StatusId: taskListResult?.Data?.SelectedStatusId,
              AssessmentTypeGroupId:
                taskListResult?.Data?.SelectedAssessmentTypeGroupId,
              // SelectedPendingApproverIdList:
              //   taskListResult?.Data?.SelectedPendingApproverIdList,
              TotalRecordsCount: statisticsResult?.Data?.TotalRecordsCount,
            } as RemediationTrackerTaskSearchParameter
          )
        );

        yield put(
          remediationTrackerTasksReducerActions.setTaskStatusSummary([
            ...(statisticsResult?.Data?.TaskStatusSummaryCount ?? []),
          ])
        );

        yield put(
          remediationTrackerTasksReducerActions.setTaskAssessmentSummary([
            ...(statisticsResult?.Data?.TaskAssessmentSummary ?? []),
          ])
        );
      }

      if (taskListResult && Object.keys(taskListResult).length !== 0) {
        yield put(setLoading(false));
        yield put(remediationTrackerTasksReducerActions.setDataLoading(false));
      }
    }
  );
};

const getRemediationTrackerTaskDetailsWatcher = function* (): any {
  yield takeEvery(
    GETREMEDIATIONTRACKERTASKSDETAILS,
    function* (action: AnyAction): any {
      // set page loading
      yield put(setLoading(true));

      const parentTaskId: number = action.payload;

      const result: ActionResponseType = yield call(() =>
        getRemediationTrackerTaskDetails({
          TaskId: parentTaskId,
        } as RemediationTrackerTaskSearchParameter)
      );
      if (!result.IsSuccess) {
        // TODO document why this block is empty
      } else {
        // yield put(
        //   remediationTrackerTasksReducerActions.setRemediationTrackerTaskDetails(
        //     {
        //       ...result?.Data,
        //       Id: 0, //skip change task count
        //     } as RemediationTrackerTaskDTO
        //   )
        // );
        const childTasks: Array<RemediationTrackerTaskGridData> = [
          ...result.Data,
        ];

        yield put(
          remediationTrackerTasksReducerActions.setChildTaskDetails({
            parentTaskId: parentTaskId,
            childTasks: childTasks,
          })
        );
      }
      yield put(setLoading(false));
    }
  );
};

// const deleteRemediationTrackerTaskWatcher = function* (): any {
//   //
//   yield takeEvery(
//     DELETEREMEDIATIONTRACKERTASK,
//     function* (action: AnyAction): any {
//       // set page loading
//       yield put(setLoading(true));

//       const remediationTrackerTaskQuestion: RemediationTrackerTaskQuestionDTO =
//         action.payload;

//       const result: ActionResponseType = yield call(() =>
//         deleteRemediationTrackerTask(
//           remediationTrackerTaskQuestion?.RemediationTrackerTask?.Id
//         )
//       );
//       if (!result.IsSuccess) {
//         yield put(
//           openPopup({
//             Open: true,
//             BodyText: result.ErrorMessage
//               ? result.ErrorMessage
//               : "An error occurred when deleting task",
//             HeaderText: "Warning",
//             PopupType: EnumPopupType.WarningPopup,
//           } as PopupProps)
//         );
//       } else {
//         //get Task List
//         const state: RemediationTrackerTasksPageType = yield select(
//           (s: RootState) => s.remediationTrackerTasksReducer
//         );

//         const result = yield call(() =>
//           getRemediationTrackerTaskDetails({
//             ...state?.RemediationTrackerTaskSearchParameter,
//             RemediationTrackerTaskSearchParams: {
//               ...state?.RemediationTrackerTaskSearchParameter
//                 ?.RemediationTrackerTaskSearchParams,
//               Id: remediationTrackerTaskQuestion?.RemediationTrackerTask?.Id,
//               InspectionQuestionId:
//                 remediationTrackerTaskQuestion?.InspectionQuestion?.Id,
//               IsMergeTask:
//                 remediationTrackerTaskQuestion?.RemediationTrackerTask
//                   ?.IsMergeTask,
//             },
//           })
//         );

//         if (result?.Data == null && !result?.Data) {
//           yield put(
//             openPopup({
//               Open: true,
//               BodyText: "An error occurred when deleting task",
//               HeaderText: "Warning",
//               PopupType: EnumPopupType.WarningPopup,
//             } as PopupProps)
//           );
//         } else {
//           yield put(
//             remediationTrackerTasksReducerActions.setRemediationTrackerTaskDetails(
//               {
//                 ...result?.Data,
//                 Id: remediationTrackerTaskQuestion?.RemediationTrackerTask?.Id,
//               } as RemediationTrackerTaskDTO
//             )
//           );
//         }
//       }

//       // set page loading
//       yield put(setLoading(false));
//     }
//   );
// };

const bulkApproveRemediationTrackerTaskWatcher = function* (): any {
  //
  yield takeEvery(
    BULKAPPROVEREMEDIATIONTRACKERTASK,
    function* (action: AnyAction): any {
      // set page loading
      yield put(setLoading(true));

      // state
      const state: RemediationTrackerTasksPageType = yield select(
        (s: RootState) => s.remediationTrackerTasksReducer
      );

      // selected Remediation Tracker Task Id List
      const selectedRemediationTrackerTask: BulkApproveRemediationTrackerTaskDTO =
        action.payload;

      const result: ActionResponseType = yield call(() =>
        bulkApproveRemediationTrackerTaskApi(selectedRemediationTrackerTask)
      );

      if (!result.IsSuccess) {
        yield put(
          openPopup({
            Open: true,
            BodyText: result.ErrorMessage
              ? result.ErrorMessage
              : "An error occurred when approve task(s)",
            HeaderText: "Warning",
            PopupType: EnumPopupType.WarningPopup,
          } as PopupProps)
        );
      } else {
        const isSameUserHasMultipleRole: boolean =
          result.Data?.IsSameUserHasMultipleRole;

        const isApproved: boolean = result.Data?.IsApproved;

        if (!isApproved) {
          yield put(
            openPopup({
              Open: true,
              BodyText: isSameUserHasMultipleRole
                ? "At least one of the selected task(s) has more than one position assigned to current user. Do you wish proceed and approve all at once?"
                : "Are you sure you want to approve the selected  task(s)?",
              HeaderText: "Confirmation",
              PopupType: EnumPopupType.YesNoConfirmation,
              YesBtnClick() {
                bulkApprovalChannel.put(
                  bulkApproveRemediationTrackerTask({
                    ...selectedRemediationTrackerTask,
                    CheckSameUserHasMultipleRole: false,
                  } as BulkApproveRemediationTrackerTaskDTO)
                );
                reducerChannel.put(
                  remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
                );
              },
              DisableBackdropClose: true,
            })
          );
        } else {
          yield put(
            openPopup({
              Open: true,
              BodyText: "Selected task(s) approved successfully",
              HeaderText: "Success",
              PopupType: EnumPopupType.SuccessPopup,
              OkBtnClick: () => {
                getRemediationTrackerTaskChannel.put(
                  getRemediationTrackerTaskList({
                    ...state.TaskSearchParameter,
                  } as RemediationTrackerTaskSearchParameter)
                );
              },
            } as PopupProps)
          );
        }
        // set page loading
        yield put(setLoading(false));
      }
    }
  );
};
const bulkRejectRemediationTrackerTaskWatcher = function* (): any {
  //
  yield takeEvery(
    BULKREJECTREMEDIATIONTRACKERTASK,
    function* (action: AnyAction): any {
      // set page loading
      yield put(setLoading(true));

      // state
      const state: RemediationTrackerTasksPageType = yield select(
        (s: RootState) => s.remediationTrackerTasksReducer
      );

      const selectedRemediationTrackerTask: BulkRejectRemediationTrackerTaskDTO =
        action.payload;

      const result: ActionResponseType = yield call(() =>
        bulkRejectRemediationTrackerTaskApi(selectedRemediationTrackerTask)
      );

      if (!result.IsSuccess) {
        yield put(
          openPopup({
            Open: true,
            BodyText: result.ErrorMessage
              ? result.ErrorMessage
              : "An error occurred when reject task(s)",
            HeaderText: "Warning",
            PopupType: EnumPopupType.WarningPopup,
          } as PopupProps)
        );
      } else {
        yield put(
          openPopup({
            Open: true,
            BodyText: "Selected task(s) rejected successfully",
            HeaderText: "Success",
            PopupType: EnumPopupType.SuccessPopup,
            OkBtnClick: () => {
              reducerChannel.put(
                remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
              );
              getRemediationTrackerTaskChannel.put(
                getRemediationTrackerTaskList({
                  ...state.TaskSearchParameter,
                } as RemediationTrackerTaskSearchParameter)
              );
            },
          } as PopupProps)
        );
      }

      // set page loading
      yield put(setLoading(false));
    }
  );
};

const mergeRemediationTrackerTasksWatcher = function* (): any {
  yield takeEvery(
    MERGEREMEDIATIONTRACKERTASKS,
    function* (action: AnyAction): any {
      yield put(setLoading(true));

      let mergeRemediationRequest: MergeRemediationRequestDTO = action.payload;

      const state: RemediationTrackerTasksPageType = yield select(
        (s: RootState) => s.remediationTrackerTasksReducer
      );

      try {
        let result: ActionResponseType = yield call(() =>
          mergeRemediationTasksApi(mergeRemediationRequest)
        );

        if (result.IsSuccess) {
          yield put(
            openPopup({
              Open: true,
              BodyText: result.InfoMessage,
              HeaderText: "Success",
              PopupType: EnumPopupType.SuccessPopup,
              OkBtnClick: () => {
                reducerChannel.put(
                  remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
                );
                reducerChannel.put(
                  remediationTrackerTasksReducerActions.setEnableCreateMergeTask(
                    false
                  )
                );
                getRemediationTrackerTaskChannel.put(
                  getRemediationTrackerTaskList({
                    ...state.TaskSearchParameter,
                  })
                );
              },
            } as PopupProps)
          );
        } else {
          yield put(
            openPopup({
              Open: true,
              BodyText:
                result.ErrorMessage ||
                "An error occurred when merging remediation tasks",
              HeaderText: "Warning",
              PopupType: EnumPopupType.WarningPopup,
              OkBtnClick: () => {},
            } as PopupProps)
          );
        }
      } catch (error) {
        yield put(
          openPopup({
            Open: true,
            BodyText: "An error occurred when merging remediation tasks",
            HeaderText: "Warning",
            PopupType: EnumPopupType.ErrorPopup,
          } as PopupProps)
        );
      }
      yield put(setLoading(false));
    }
  );
};

const deleteRemediationTrackerTasksWatcher = function* (): any {
  yield takeEvery(
    DELETEREMEDIATIONTRACKERTASK,
    function* (action: AnyAction): any {
      yield put(setLoading(true));

      let remediationTrackerId: number = action.payload;
      const state: RemediationTrackerTasksPageType = yield select(
        (s: RootState) => s.remediationTrackerTasksReducer
      );

      try {
        let result: ActionResponseType = yield call(() =>
          deleteRemediationTasksSubtasksApi(remediationTrackerId)
        );

        if (result.IsSuccess) {
          yield put(
            openPopup({
              Open: true,
              BodyText: "Sub task deleted successfully.",
              HeaderText: "Success",
              PopupType: EnumPopupType.SuccessPopup,
              OkBtnClick: () => {
                getRemediationTrackerTaskChannel.put(
                  getRemediationTrackerTaskList({
                    ...state.TaskSearchParameter,
                  })
                );
              },
            } as PopupProps)
          );
        } else {
          yield put(
            openPopup({
              Open: true,
              BodyText:
                result.ErrorMessage ||
                "An error occurred when deleting remediation tasks",
              HeaderText: "Error",
              PopupType: EnumPopupType.ErrorPopup,
              OkBtnClick: () => {},
            } as PopupProps)
          );
        }
      } catch (error) {
        yield put(
          openPopup({
            Open: true,
            BodyText: "An error occurred when deleting remediation tasks",
            HeaderText: "Warning",
            PopupType: EnumPopupType.ErrorPopup,
          } as PopupProps)
        );
      }
      yield put(setLoading(false));
    }
  );
};

const unMergeRemediationTrackerTasksWatcher = function* (): any {
  yield takeEvery(
    UNMERGEREMEDIATIONTRACKERTASKS,
    function* (action: AnyAction): any {
      yield put(setLoading(true));

      let remediationTrackerId: number = action.payload;
      const state: RemediationTrackerTasksPageType = yield select(
        (s: RootState) => s.remediationTrackerTasksReducer
      );

      try {
        let result: ActionResponseType = yield call(() =>
          unMergeRemediationTasksApi(remediationTrackerId)
        );

        if (result.IsSuccess) {
          yield put(
            openPopup({
              Open: true,
              BodyText: "Task unmerged successfully.",
              HeaderText: "Success",
              PopupType: EnumPopupType.SuccessPopup,
              OkBtnClick: () => {
                reducerChannel.put(
                  remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
                );
                reducerChannel.put(
                  remediationTrackerTasksReducerActions.setEnableUnMergeTask(
                    false
                  )
                );
                getRemediationTrackerTaskChannel.put(
                  getRemediationTrackerTaskList({
                    ...state.TaskSearchParameter,
                  })
                );
              },
            } as PopupProps)
          );
        } else {
          yield put(
            openPopup({
              Open: true,
              BodyText:
                result.ErrorMessage ||
                "An error occurred when unmerging remediation tasks",
              HeaderText: "Warning",
              PopupType: EnumPopupType.WarningPopup,
              OkBtnClick: () => {},
            } as PopupProps)
          );
        }
      } catch (error) {
        yield put(
          openPopup({
            Open: true,
            BodyText: "An error occurred when unmerging remediation tasks",
            HeaderText: "Warning",
            PopupType: EnumPopupType.ErrorPopup,
          } as PopupProps)
        );
      }
      yield put(setLoading(false));
    }
  );
};

const getRemediationTrackerTaskQuestionDetailsWatcher = function* (): any {
  yield takeEvery(
    GETREMEDIATIONtASKQUESTIONDETAILS,
    function* (action: AnyAction): any {
      yield put(setLoading(true));

      let remediation: RemediationTrackerTaskQuestionsRequestDTO =
        action.payload;

      try {
        let result: ActionResponseType = yield call(() =>
          getRemediationTrackerTaskQuestionDetailsApi(remediation)
        );

        if (result.IsSuccess) {
          const data = result.Data?.map((d, index) => {
            return { ...d, Id: index };
          });

          yield put(
            remediationTrackerTasksReducerActions.setViewDetailspopUpData({
              OpenPopup: true,
              Data: data,
            } as ViewDetailsPopupDataType)
          );
        } else {
          yield put(
            openPopup({
              Open: true,
              BodyText:
                result.ErrorMessage ||
                "An error occurred when getting question details",
              HeaderText: "Error",
              PopupType: EnumPopupType.ErrorPopup,
              OkBtnClick: () => {},
            } as PopupProps)
          );
        }
      } catch (error) {
        yield put(
          openPopup({
            Open: true,
            BodyText: "An error occurred when getting question details",
            HeaderText: "Warning",
            PopupType: EnumPopupType.ErrorPopup,
          } as PopupProps)
        );
      }
      yield put(setLoading(false));
    }
  );
};

const checkBulkApproveRemediationTrackerTaskWatcher = function* (): any {
  yield takeEvery(
    CHECKBULKAPPROVEREMEDIATIONTRACKERTASK,
    function* (action: AnyAction): any {
      // set page loading
      yield put(setLoading(true));

      const selectedTasks: ParentChildApprovalRejectionDataDTO = action.payload;

      const result: ActionResponseType = yield call(() =>
        CheckBulkApproveRejectRemediationTrackerTaskApi({
          ParentChildApprovalDTO: selectedTasks.ParentChildDataList,
          IsApproval: true,
        } as CheckApprovalDTO)
      );

      if (result.IsSuccess) {
        yield put(
          openPopup({
            Open: true,
            BodyText: result.InfoMessage,
            HeaderText: "Confirmation",
            PopupType: EnumPopupType.YesNoConfirmation,
            YesBtnClick: () => {
              bulkApprovalChannel.put(
                bulkApproveRemediationTrackerTask({
                  SelectedRemediationTrackerTaskIdList: result.Data ?? [],
                  CheckSameUserHasMultipleRole: true,
                } as BulkApproveRemediationTrackerTaskDTO)
              );
            },
            NoBtnClick: () => {
              setPopupOpen(false);
            },
            DisableBackdropClose: true,
          } as PopupProps)
        );
      } else {
        yield put(
          openPopup({
            Open: true,
            BodyText:
              result.ErrorMessage ||
              "An unexpected error occurred while approving task(s).",
            HeaderText: "Warning",
            PopupType: EnumPopupType.ErrorPopup,
          } as PopupProps)
        );
      }
      yield put(setLoading(false));
    }
  );
};

const CheckbulkRejectRemediationTrackerTaskWatcher = function* (): any {
  yield takeEvery(
    CHECKBULKREJECTREMEDIATIONTRACKERTASK,
    function* (action: AnyAction): any {
      // set page loading
      yield put(setLoading(true));

      const selectedTasks: ParentChildApprovalRejectionDataDTO = action.payload;

      const result: ActionResponseType = yield call(() =>
        CheckBulkApproveRejectRemediationTrackerTaskApi({
          ParentChildApprovalDTO: selectedTasks.ParentChildDataList,
          IsApproval: false,
        } as CheckApprovalDTO)
      );

      if (result.IsSuccess) {
        yield put(
          openPopup({
            Open: true,
            BodyText: result.InfoMessage,
            HeaderText: "Confirmation",
            PopupType: EnumPopupType.YesNoConfirmation,
            YesBtnClick: () => {
              // Open the text input popup for rejection reason
              bulkRejectChannel.put(
                openPopup({
                  Open: true,
                  HeaderText: "Reason for Rejection",
                  LableText: "Reason for Rejection",
                  InputText: "",
                  Required: true,
                  CancelButtonText: "Discard",
                  YesButtonText: "Confirm",
                  PopupType: EnumPopupType.TextInputPopup,
                  InputTextCount: 100,
                  ActionBtnClick: (value: string, closePopup: () => void) => {
                    if (value.trim().length > 0) {
                      bulkRejectChannel.put(
                        bulkRejectRemediationTrackerTask({
                          SelectedRemediationTrackerTaskIdList:
                            result.Data ?? [],
                          RemediationTrackerTaskRejectReason: {
                            Id: 0,
                            Comment: value,
                          } as RemediationTrackerTaskCommentDTO,
                        } as BulkRejectRemediationTrackerTaskDTO)
                      );
                      closePopup();
                    } else {
                      bulkRejectChannel.put(
                        updatePopupProps({
                          ErrorMessage: "Please enter a reason for rejection",
                        })
                      );
                    }
                  },
                  CloseBtnClick: () => {
                    setPopupOpen(false);
                  },
                  DisableBackdropClose: true,
                } as PopupProps)
              );
            },
            NoBtnClick: () => {
              setPopupOpen(false);
            },
            DisableBackdropClose: true,
          } as PopupProps)
        );
      } else {
        yield put(
          openPopup({
            Open: true,
            BodyText:
              result.ErrorMessage ||
              "An unexpected error occurred while approving task(s).",
            HeaderText: "Warning",
            PopupType: EnumPopupType.ErrorPopup,
          } as PopupProps)
        );
      }
      yield put(setLoading(false));
    }
  );
};

const remediationTrackerTaskListSaga = function* () {
  yield all([
    getRemediationTrackerTaskInitialDataWatcher(),
    getRemediationTrackerTaskListWatcher(),
    getRemediationTrackerTaskDetailsWatcher(),
    // deleteRemediationTrackerTaskWatcher(),
    bulkApproveRemediationTrackerTaskWatcher(),
    bulkRejectRemediationTrackerTaskWatcher(),
    //getRemediationTrackerTaskColumnWiseFilterWatcher(),
    bulkApprovalChannelWatcher(),
    bulkRejectChannelWatcher(),
    checkBulkApproveRemediationTrackerTaskWatcher(),
    CheckbulkRejectRemediationTrackerTaskWatcher(),
    getRemediationTrackerTaskChannelWatcher(),
    mergeRemediationTrackerTasksWatcher(),
    deleteRemediationTrackerTasksWatcher(),
    unMergeRemediationTrackerTasksWatcher(),
    getRemediationTrackerTaskQuestionDetailsWatcher(),
    reducerChannelWatcher(),
  ]);
};

export default remediationTrackerTaskListSaga;
